module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isRecommendedNewArrivals) ? _c('div', [_c('TopSellingSection', {
    attrs: {
      "callerComp": "new arrival",
      "renderName": _vm.renderName,
      "renderData": _vm.recommNewArrivalsData.concat( [_vm.renderData[_vm.renderData.length - 1]])
    }
  })], 1) : (_vm.renderData && _vm.renderData.length && _vm.renderData.length > 1) ? _c('div', {
    staticClass: "newarrivalcard"
  }, [_c('div', {
    staticClass: "newarrivalcard__title-cont"
  }, [(_vm.renderName) ? _c('h3', {
    staticClass: "title",
    class: !_vm.isDesktop ? 'text-left pl-4' : ''
  }, [_vm._v(_vm._s(_vm.renderName))]) : _vm._e(), _vm._v(" "), (_vm.getDescription) ? _c('p', {
    staticClass: "descrition"
  }, [_vm._v(_vm._s(_vm.getDescription))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "loop": true,
      "autoplay": _vm.shouldAutoPlay,
      "speed": 500,
      "autoplayTimeout": 6000,
      "perPage": _vm.isDesktop ? 2 : 1,
      "perPageCustom": [
        [213, 1.3],
        [480, 1.3],
        [768, 1.3],
        [1200, 3],
        [1920, 4]
      ]
    }
  }, _vm._l((_vm.renderData.slice(0, _vm.renderData.length - 1)), function(prm, index) {
    return _c('slide', {
      key: index,
      class: _vm.isDesktop ? 'col-md-4 col-6' : 'custom-slide'
    }, [_c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(prm, index)),
        expression: "getBannerImpressionData(prm, index)"
      }],
      staticClass: "card-container pointer",
      class: _vm.isDesktop ? null : 'm-1',
      attrs: {
        "href": _vm.getRedirectionUrl(prm),
        "role": "link"
      },
      on: {
        "click": function($event) {
          _vm.getRedirectionLink(prm, index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.newArrivalShimmerLoading[index]),
        expression: "newArrivalShimmerLoading[index]"
      }]
    }, [_c('NewArrivalPlaceholder', {
      attrs: {
        "styleObject": _vm.childStyles
      }
    })], 1), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.newArrivalShimmerLoading[index]),
        expression: "!newArrivalShimmerLoading[index]"
      }],
      staticClass: "img-card customFade img-auto",
      attrs: {
        "data-url": _vm.getBannerImage(prm.image),
        "alt": prm.is_pdp ? prm.product_slug : prm.url,
        "title": prm.is_pdp ? prm.product_slug : prm.url,
        "width": "480",
        "height": "460"
      },
      on: {
        "load": function($event) {
          _vm.onImageLoad(index)
        },
        "error": function($event) {
          _vm.onImageError(index)
        }
      }
    })])])
  }))], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c79e882"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NewArrivalsCard.vue
// module id = 2444
// module chunks = 50